import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore, VipCookieName } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AppContextConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getApiBaseUri(): string {
		return this.configService.get((x) => x.core.appContext.apiBaseUri);
	}

	getApiToken(): string {
		return this.configService.get((x) => x.core.appContext.apiToken);
	}

	getSessionToken(): string {
		return this.configService.get((x) => x.core.appContext.sessionToken);
	}

	getAssetBaseUri(): string {
		return this.configService.get((x) => x.core.appContext.assetBaseUri);
	}

	/**
	 * Gets the Jurisdiction value from app context configuration
	 *
	 * Note: this function is primarily used externally
	 */
	getJurisdiction(): string {
		return this.configService.get((x) => x.core.appContext.jurisdiction);
	}

	getBetaCookieExpiry(): number {
		return this.configService.get((x) => x.core.appContext.betaCookieDuration, 2);
	}

	isBeta(): boolean {
		return this.configService.get((x) => x.core.appContext.beta!.isBeta, false);
	}

	getIsAlternativeBetaBadgeLocation(): boolean {
		return this.configService.get((x) => x.core.appContext.beta!.alternativeBetaLinkLocation, true);
	}

	showBetaLabel(): boolean {
		return this.configService.get((x) => x.core.appContext.beta!.showBetaLabel, false);
	}

	showBetaLink(): boolean {
		return this.configService.get((x) => x.core.appContext.beta!.showBetaLink, false);
	}

	getDisabledMarketsForBetaLink(): string[] {
		return this.configService.get((x) => x.core.appContext.beta!.disableBetaLinkByMarket, []);
	}

	getRedirectUrl(): string {
		return this.configService.get((x) => x.core.appContext.beta!.redirectUrl);
	}

	getVipCookieDetails(): VipCookieName {
		return this.configService.get((x) => x.core.appContext.vipCookieName, {
			cookieName: "VIP",
			emailField: "EmailAddress",
		});
	}
}
